import { apiAction } from 'actions/application'
import { createAction } from 'actions/utils'
import * as services from 'services/search'
import { FAST_FEATURES, FEATURE_COLLECTIONS } from 'utils/constants'

export const ADS_START_SEARCH = 'ADS_START_SEARCH'
export const startSearch = createAction(ADS_START_SEARCH, [
  'collectionName',
  'searchUri',
  'addToSearchRequestBody',
  'fetchFilters',
])

export const ADS_END_SEARCH = 'ADS_END_SEARCH'
export const endSearch = createAction(ADS_END_SEARCH)

export const ADS_SET_FILTERS = 'ADS_SET_FILTERS'
export const setFilters = createAction(ADS_SET_FILTERS, [
  'filters',
  'collectionName',
])

export const ADS_SET_CHIP_FILTERS = 'ADS_SET_CHIP_FILTERS'
export const setChipFilters = createAction(ADS_SET_CHIP_FILTERS, [
  'chipFilters',
  'collectionName',
])

export const ADS_RESET_CHIP_FILTERS = 'ADS_RESET_CHIP_FILTERS'
export const resetChipFilters = createAction(ADS_RESET_CHIP_FILTERS, [
  'chipFilters',
  'collectionName',
])

export const ADS_HANDLE_SUBMIT_SEARCH = 'ADS_HANDLE_SUBMIT_SEARCH'
export const handleSubmitSearch = createAction(ADS_HANDLE_SUBMIT_SEARCH, [
  'collectionName',
  'resetPagination',
  'fetchResults',
  'addToSearchRequestBody',
])

export const ADS_SUBMIT_SEARCH_START = 'ADS_SUBMIT_SEARCH_START'
export const submitSearchStart = createAction(ADS_SUBMIT_SEARCH_START, [
  'start',
  'collectionName',
])

export const ADS_SUBMIT_SEARCH = 'ADS_SUBMIT_SEARCH'
export const submitSearch = createAction(ADS_SUBMIT_SEARCH, [
  'collectionName',
  'resetPagination',
  'addToSearchRequestBody',
])

export const ADS_HANDLE_ADD_FILTER_TERM = 'ADS_HANDLE_ADD_FILTER_TERM'
export const handleAddFilterTerm = createAction(ADS_HANDLE_ADD_FILTER_TERM, [
  'primaryFilter',
  'secondaryFilter',
  'groupName',
  'collectionName',
])

export const ADS_CREATE_FILTER_TERM = 'ADS_CREATE_FILTER_TERM'
export const createFilterTerm = createAction(ADS_CREATE_FILTER_TERM, [
  'primaryFilter',
  'secondaryFilter',
  'groupName',
  'collectionName',
])

export const ADS_HANDLE_CLEAR_FILTER_TERMS = 'ADS_HANDLE_CLEAR_FILTER_TERMS'
export const handleClearFilterTerms = createAction(
  ADS_HANDLE_CLEAR_FILTER_TERMS,
  ['collectionName']
)

export const ADS_HANDLE_CLEAR_PRODUCTION_SCHEDULE_FILTER =
  'ADS_HANDLE_CLEAR_PRODUCTION_SCHEDULE_FILTER'
export const handleClearProductionScheduleFilter = createAction(
  ADS_HANDLE_CLEAR_PRODUCTION_SCHEDULE_FILTER,
  ['collectionName']
)

export const ADS_HANDLE_REMOVE_FILTER_TERM = 'ADS_HANDLE_REMOVE_FILTER_TERM'
export const handleRemoveFilterTerm = createAction(
  ADS_HANDLE_REMOVE_FILTER_TERM,
  ['value', 'collectionName']
)

export const ADS_HANDLE_CLEAR_SEARCH = 'ADS_HANDLE_CLEAR_SEARCH'
export const handleClearSearch = createAction(ADS_HANDLE_CLEAR_SEARCH, [
  'collectionName',
])

export const ADS_HANDLE_CLEAR_ALL_ADVANCED_SEARCH =
  'ADS_HANDLE_CLEAR_ALL_ADVANCED_SEARCH'
export const handleClearAllAdvancedSearch = createAction(
  ADS_HANDLE_CLEAR_ALL_ADVANCED_SEARCH,
  ['collectionName']
)

export const ADS_SET_FILTER_TERMS = 'ADS_SET_FILTER_TERMS'
export const setFilterTerms = createAction(ADS_SET_FILTER_TERMS, [
  'filters',
  'collectionName',
])

// can be legacy and not use for RP search
export const ADS_SET_FILTER_SELECTION = 'ADS_SET_FILTER_SELECTION'
export const setFilterSelection = createAction(ADS_SET_FILTER_SELECTION, [
  'filterKey',
  'value',
  'collectionName',
])

export const ADS_SET_DROPDOWN_SELECTION_BY_KEY =
  'ADS_SET_DROPDOWN_SELECTION_BY_KEY'
export const setDropdownSelectionByKey = createAction(
  ADS_SET_DROPDOWN_SELECTION_BY_KEY,
  ['selectedValue', 'collectionName', 'dropdownKey']
)

// driver selector
export const ADS_CREATE_ADD_FILTER_TERM = 'ADS_CREATE_ADD_FILTER_TERM'
export const createAndAddFilterTerm = createAction(ADS_CREATE_ADD_FILTER_TERM, [
  'collectionName',
  'dropdownKey',
])

export const ADS_CREATE_ADD_FILTER_TERM_FROM_DASH =
  'ADS_CREATE_ADD_FILTER_TERM_FROM_DASH'
export const createAndAddFilterTermFromDash = createAction(
  ADS_CREATE_ADD_FILTER_TERM_FROM_DASH,
  [
    'schema',
    'value',
    'filterType',
    'switches',
    'switchName',
    'collectionName',
    'serialNumber',
  ]
)

export const ADS_CREATE_ADD_FILTER_TERM_FROM_ECU =
  'ADS_CREATE_ADD_FILTER_TERM_FROM_ECU'
export const createAndAddFilterTermFromEcu = createAction(
  ADS_CREATE_ADD_FILTER_TERM_FROM_ECU,
  ['selectedPin', 'filterType', 'serialNumber', 'collectionName']
)

export const ADS_CREATE_ADD_FILTER_TERM_DASH_BUILDER_PRODUCTION_SHCEDULE =
  'ADS_CREATE_ADD_FILTER_TERM_DASH_BUILDER_PRODUCTION_SHCEDULE'
export const createAndAddFilterTermProductionSchedule = createAction(
  ADS_CREATE_ADD_FILTER_TERM_DASH_BUILDER_PRODUCTION_SHCEDULE,
  ['collectionName']
)

export const ADS_SET_FILTER_TERM = 'ADS_SET_FILTER_TERM'
export const setFilterTerm = createAction(ADS_SET_FILTER_TERM, [
  'filterTerm',
  'collectionName',
])

export const ADS_SET_FILTER_TERM_FROM_DASH = 'ADS_SET_FILTER_TERM_FROM_DASH'
export const setFilterTermFromDash = createAction(
  ADS_SET_FILTER_TERM_FROM_DASH,
  ['filterTerm', 'collectionName']
)

export const ADS_SET_FILTER_TERM_FROM_ECU = 'ADS_SET_FILTER_TERM_FROM_ECU'
export const setFilterTermFromEcu = createAction(ADS_SET_FILTER_TERM_FROM_ECU, [
  'filterTerm',
  'collectionName',
])

export const ADS_SET_FAST_FEATURES_FILTERS_FROM_ECU_DASH =
  'ADS_SET_FAST_FEATURES_FILTERS_FROM_ECU_DASH'
export const setFastFeaturesFiltersFromEcuAndDash = createAction(
  ADS_SET_FAST_FEATURES_FILTERS_FROM_ECU_DASH,
  ['filters']
)

export const ADS_RESET_SEARCH = 'ADS_RESET_SEARCH'

export const ADS_RESET_ALL_SEARCH = 'ADS_RESET_ALL_SEARCH'
export const resetAllSearch = createAction(ADS_RESET_ALL_SEARCH, [
  'collectionName',
])

export const ADS_CLEAR_FILTER_TERMS = 'ADS_CLEAR_FILTER_TERMS'
export const clearFilterTerms = createAction(ADS_CLEAR_FILTER_TERMS, [
  'collectionName',
])

export const ADS_CLEAR_ALL_DROPDOWNS = 'ADS_CLEAR_ALL_DROPDOWNS'
export const clearAllDropdowns = createAction(ADS_CLEAR_ALL_DROPDOWNS, [
  'collectionName',
])

export const ADS_RESET_DASH_BUILDER_SELECTED_DAYS_OUT =
  'ADS_RESET_DASH_BUILDER_SELECTED_DAYS_OUT'
export const resetSelectedDaysOut = createAction(
  ADS_RESET_DASH_BUILDER_SELECTED_DAYS_OUT,
  ['collectionName']
)

export const ADS_REMOVE_FILTER_TERM = 'ADS_REMOVE_FILTER_TERM'
export const removeFilterTerm = createAction(ADS_REMOVE_FILTER_TERM, [
  'value',
  'collectionName',
])

export const ADS_CLEAR_DROPDOWN_BY_KEY = 'ADS_CLEAR_DROPDOWN_BY_KEY'
export const clearDropdownByKey = createAction(ADS_CLEAR_DROPDOWN_BY_KEY, [
  'collectionName',
  'dropdownKey',
])

export const ADS_SET_IS_SEARCHING = 'ADS_SET_IS_SEARCHING'
export const setIsSearching = createAction(ADS_SET_IS_SEARCHING, [
  'isSearching',
])

export const ADS_SET_SEARCH_STRING = 'ADS_SET_SEARCH_STRING'
export const setSearchString = createAction(ADS_SET_SEARCH_STRING, [
  'searchString',
  'collectionName',
])

export const ADS_SET_BUS_FILTER_FLAG = 'ADS_SET_BUS_FILTER_FLAG'
export const setBusFilterFlag = createAction(ADS_SET_BUS_FILTER_FLAG, [
  'collectionName',
  'busFilterFlag',
])

export const ADS_CLEAR_SEARCH_STRING = 'ADS_CLEAR_SEARCH_STRING'
export const clearSearchString = createAction(ADS_CLEAR_SEARCH_STRING, [
  'collectionName',
])

export const ADS_HANDLE_PAGINATE_SEARCH = 'ADS_HANDLE_PAGINATE_SEARCH'
export const handlePaginateSearch = createAction(ADS_HANDLE_PAGINATE_SEARCH, [
  'page',
  'collectionName',
  'addToSearchRequestBody',
])

export const ADS_HANDLE_PRODUCTION_PAGINATE_SEARCH =
  'ADS_HANDLE_PRODUCTION_PAGINATE_SEARCH'
export const handleProductionSchedulePaginateSearch = createAction(
  ADS_HANDLE_PRODUCTION_PAGINATE_SEARCH,
  ['page', 'collectionName']
)

export const ADS_SET_COLLECTION_STARTINDEX = 'ADS_SET_COLLECTION_STARTINDEX'
export const setCollectionStartIndex = createAction(
  ADS_SET_COLLECTION_STARTINDEX,
  ['startIndex', 'collectionName']
)

export const ADS_RESET_COLLECTION_STARTINDEX = 'ADS_RESET_COLLECTION_STARTINDEX'
export const resetCollectionStartIndex = createAction(
  ADS_RESET_COLLECTION_STARTINDEX,
  ['collectionName']
)

export const ADS_RESET_COLLECTION_SEARCH_RESULTS_AND_INITIAL_STATE =
  'ADS_RESET_COLLECTION_SEARCH_RESULTS_AND_INITIAL_STATE'
export const resetCollectionSearchResultsAndInitialState = createAction(
  ADS_RESET_COLLECTION_SEARCH_RESULTS_AND_INITIAL_STATE,
  ['collectionName']
)

export const ADS_GET_FILTER_DATA_BY_COLLECTION =
  'ADS_GET_FILTER_DATA_BY_COLLECTION'
export const ADS_SET_FILTER_DATA_BY_COLLECTION =
  'ADS_SET_FILTER_DATA_BY_COLLECTION'
export const ADS_GET_FILTER_DATA_BY_COLLECTION_FAILURE =
  'ADS_GET_FILTER_DATA_BY_COLLECTION_FAILURE'
export const fetchFilterDataByCollection = ({
  collectionName,
  busFilterFlag,
  conditionalSelector,
}) =>
  apiAction({
    asyncFn: services.getCollectionFilters,
    args: { collectionName, busFilterFlag },
    successActionType: ADS_SET_FILTER_DATA_BY_COLLECTION,
    failureActionType: ADS_GET_FILTER_DATA_BY_COLLECTION_FAILURE,
    conditionalSelector,
    id: collectionName,
  })

export const ADS_SET_SEARCH_RESULTS = 'ADS_SET_SEARCH_RESULTS'
export const setFeatureCollectionSearchResults = createAction(
  ADS_SET_SEARCH_RESULTS,
  ['collectionName', FEATURE_COLLECTIONS, 'total']
)

export const setFastFeaturesSearchResults = createAction(
  ADS_SET_SEARCH_RESULTS,
  ['collectionName', FAST_FEATURES, 'total']
)

export const ADS_SET_TOTAL_DASH_BUILDER_PRODUCTION_SCHEDULE_RECORDS =
  'ADS_SET_TOTAL_DASH_BUILDER_PRODUCTION_SCHEDULE_RECORDS'
export const setTotalProductionScheduleRecords = createAction(
  ADS_SET_TOTAL_DASH_BUILDER_PRODUCTION_SCHEDULE_RECORDS,
  ['total', 'collectionName']
)

export const ADS_FETCH_SEARCH_RESULTS_FAILURE =
  'ADS_FETCH_SEARCH_RESULTS_FAILURE'

export const fetchSearchResults = ({
  uri,
  collectionName,
  requestBody = null,
}) =>
  apiAction({
    asyncFn: services.getSearchResults,
    args: { uri, collectionName, requestBody },
    successActionType: ADS_SET_SEARCH_RESULTS,
    failureActionType: ADS_FETCH_SEARCH_RESULTS_FAILURE,
    id: collectionName,
  })

export const fetchDashBuilderFilterData = () =>
  apiAction({
    asyncFn: services.getDashbuilderCollectionFilters,
    successActionType: ADS_SET_FILTER_DATA_BY_COLLECTION,
    id: 'dashboard',
  })

export const ADS_SET_SELECTED_DASH_BUILDER_DAYS_OUT =
  'ADS_SET_SELECTED_DASH_BUILDER_DAYS_OUT'
export const setProductionSelectedDaysOut = createAction(
  ADS_SET_SELECTED_DASH_BUILDER_DAYS_OUT,
  ['selectedScheduleDaysOut', 'collectionName']
)

export const GET_SEARCH_SUCCESS = 'GET_SEARCH_SUCCESS'
export const GET_SEARCH_FAILURE = 'GET_SEARCH_FAILURE'
export const GET_SEARCH_REQUEST = 'GET_SEARCH_REQUEST'
export const getSearch = ({
  collectionName,
  queryString,
  isSearching,
  method,
  body,
}) =>
  apiAction({
    asyncFn: services.getSearch,
    args: { collectionName, queryString, isSearching, method, body },
    successActionType: GET_SEARCH_SUCCESS,
    requestActionType: GET_SEARCH_REQUEST,
    id: collectionName,
  })

export const ADS_UPDATE_SEARCH_RESULT_ITEM = 'ADS_UPDATE_SEARCH_RESULT_ITEM'
export const updateSearchResultItem = createAction(
  ADS_UPDATE_SEARCH_RESULT_ITEM,
  ['collectionName', 'itemId', 'updatedData']
)
